




import { Component, Vue, Prop } from 'vue-property-decorator';
import { QuoteHistory } from '@/models/quote-history';

@Component
export default class QuoteHistoryDescription extends Vue {
    @Prop({ required: true }) public entry: QuoteHistory;

    public get description(): string {
        switch (this.entry.name) {
        case 'QuoteCreated':
            return `Quote created by ${this.entry.generatedBy}`;
        case 'QuoteStatusChanged':
            return `Quote status changed to '${this.statusDescription(this.entry.data.status)}'`;
        case 'ApprovalAccepted':
            return `Quote approved by ${this.entry.generatedBy}`;
        case 'ApprovalRejected':
            return `Quote rejected by ${this.entry.generatedBy}`;
        case 'ApprovalCreated':
            return `Approval created`;
        case 'QuoteAccepted':
            return `Quote status changed to 'Approved'`;
        case 'QuoteOrdered':
            return `Order placed by ${this.entry.generatedBy}`;
        case 'QuoteOrderReceived':
            return `Order status changed to 'Received'`;
        case 'QuoteOrderDelivered':
            return `Order status changed to 'Delivered'`;
        default:
            return this.entry.name;
        }
    }

    private statusDescription(status: number): string {
        switch (status) {
        case 0:
            return `Awaiting approval`;
        case 1:
            return `Approved`;
        case 2:
            return `Rejected`;
        case 3:
            return `Order placed`;
        case 4:
            return `Order received`;
        case 5:
            return `Order delivered`;
        default:
            return `Unknown`;
        }
    }
}
